import getEnvironment from './get.environment';
import getUrlParameters from './get.url.parameters';

export default function getClientId() {
   const clientId = {
      localhost: 'client1',
      dev: 'mct-dev',
      dev1: 'mct-dev',
      development: 'mct-dev',
      test: 'mct-test',
      imp: 'mct-imp',
      implementation: 'mbp-imp2',
      production: 'mbp',
      default: 'mbp',
   };
   const urlParameters = getUrlParameters();
   return urlParameters.client_id || clientId[getEnvironment()];
}